const isLocal = window.location.hostname === "localhost";
const REACT_APP_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_CRICKET_API_URL ||
  "";

// 1. AUTH API URL (Login/Signup ke liye - Win11 Backend)
export const API_URL = isLocal
  ? "http://localhost:5000"   // Agar local par auth test kar rahe ho
  : "https://win-11-api.vercel.app"; 

// 2. CRICKET API URL (Live Score/Fantasy ke liye - New Backend)
export const CRICKET_API_URL = REACT_APP_BASE_URL || (isLocal
  ? "http://localhost:5100"
  : "https://cricket-api-orpin.vercel.app");
